import { rfqQuoteDetailsProposedDetailsGridStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGrid";
import { css } from "styled-components";

Object.assign(rfqQuoteDetailsProposedDetailsGridStyles, {
    totalValueText: {
        size: 16,
    },
    totalLabelText: {
        size: 16,
        weight: 600,
        css: css`
            margin-right: 10px;
        `,
    },
});
